export type BaseReport = {
  reportId: string;
  reportName: string;
  draft?: boolean;
};

export function reportGetKey(item: BaseReport) {
  return item.reportId;
}

export function reportGetValue(item: BaseReport) {
  return item.reportName;
}
